export const OAUTH_RETURN_PATH_KEY = 'skyspaceOAuthReturnPath';
export const MODERN_OAUTH_RETURN_PATH = '/modern/';

function hasOAuthResponse(params: URLSearchParams): boolean {
  return Boolean(
    params.get('state')
    && (params.get('code') || params.get('error')),
  );
}

export function oauthCallbackParams(
  hash: string,
  search: string,
): URLSearchParams | undefined {
  const fragment = new URLSearchParams(hash.replace(/^#/, ''));
  if (hasOAuthResponse(fragment)) return fragment;
  const query = new URLSearchParams(search.replace(/^\?/, ''));
  return hasOAuthResponse(query) ? query : undefined;
}

export function cleanOAuthCallbackUrl(pathname: string): string {
  return modernApplicationPath(pathname);
}

export function modernApplicationPath(pathname: string): '/' | '/modern/' {
  return pathname === '/modern' || pathname.startsWith('/modern/')
    ? MODERN_OAUTH_RETURN_PATH
    : '/';
}

export function modernOAuthRedirectUri(origin: string, pathname: string): string {
  const applicationPath = modernApplicationPath(pathname);
  return applicationPath === '/'
    ? origin
    : `${origin}${applicationPath}`;
}
